import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SharedModule } from '@aiwyn/shared';
import { CxpDeliverableContact, CxpDeliverableTeamMember } from '../../../../models';
import { getCxpContactInitials } from '../../../../shared';

@Component({
  selector: 'cxp-deliverable-details-sidebar',
  templateUrl: './deliverable-details-sidebar.component.html',
  styleUrls: ['./deliverable-details-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule],
})
export class DeliverableDetailsSidebarComponent {
  readonly clientContacts = input<CxpDeliverableContact[]>([]);
  readonly teamMembers = input<CxpDeliverableTeamMember[]>([]);
  /**
   * When true, the sidebar still renders its frame + section titles but
   * shows a "Loading" placeholder in place of each list. Lets the rail
   * occupy its space immediately on page load so the layout doesn't shift
   * once the backend payload arrives.
   */
  readonly isLoading = input(false);

  initialsForContact(contact: CxpDeliverableContact): string {
    return getCxpContactInitials(contact.fullName, contact.email);
  }

  initialsForTeamMember(member: CxpDeliverableTeamMember): string {
    return getCxpContactInitials(member.fullName, member.email);
  }
}
